import { takeLatest } from 'redux-saga/effects';
import * as types from './reducer';
import {getCoursesSaga} from "./handler";

export default function* watchCourses() {
    yield takeLatest(types.GET_COURSES, getCoursesSaga);
}
